const css = `.activity-view-toggle {
  position: relative;
  display: inline-flex;
  margin: 0;
  padding: 0;
  border: 0;
}
.activity-view-toggle legend {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
.activity-view-toggle label {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: 0;
  background: var(--surface-raised);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
  cursor: pointer;
}
.activity-view-toggle label i {
  color: inherit;
}
.activity-view-toggle label + label {
  border-left-width: 0;
}
.activity-view-toggle label:first-of-type {
  border-top-left-radius: var(--radius-md);
  border-bottom-left-radius: var(--radius-md);
}
.activity-view-toggle label:last-of-type {
  border-top-right-radius: var(--radius-md);
  border-bottom-right-radius: var(--radius-md);
}
.activity-view-toggle label:hover {
  color: var(--text);
  background: var(--surface-hover);
}
.activity-view-toggle label.selected {
  color: var(--accent-text);
  background: var(--accent);
  border-color: var(--accent);
}
.activity-view-toggle label.selected:hover {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}
.activity-view-toggle label:has(input:focus-visible) {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
  z-index: 1;
}
.activity-view-toggle input {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  pointer-events: none;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.activity-timeline-empty {
  margin: 0;
  padding: var(--space-6) 0;
  text-align: center;
  color: var(--text-muted);
}

.activity-timeline {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}
.activity-timeline ul {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
}
.activity-timeline ul li + li {
  border-top: 1px solid var(--border);
}
.activity-timeline .activity-timeline-day h4 {
  margin: 0 0 var(--space-2);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
}
.activity-timeline .activity-timeline-day.today h4 {
  color: var(--accent);
}

.activity-timeline-item {
  display: grid;
  grid-template-columns: 112px auto 1fr auto;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-3) var(--space-4);
  border: 0;
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  text-align: left;
}
.activity-timeline-item:is(button) {
  cursor: pointer;
}
.activity-timeline-item:is(button):hover {
  background: var(--surface-hover);
}
.activity-timeline-item:is(button):focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

.activity-timeline-time {
  font-size: var(--font-size-sm);
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
}

.activity-timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.activity-timeline-body {
  display: flex;
  flex-direction: column;
  gap: var(--space-0-5);
  min-width: 0;
}

.activity-timeline-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}

.activity-timeline-details {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.activity-timeline-aside {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}
.activity-timeline-aside.danger {
  color: var(--danger);
}
.activity-timeline-aside.strong {
  font-size: var(--font-size-sm);
  color: var(--text);
}

@media (max-width: 767px) {
  .activity-timeline-item {
    grid-template-columns: auto 1fr auto;
    row-gap: var(--space-1);
  }
  .activity-timeline-item .activity-timeline-time {
    grid-column: 1/-1;
    font-size: var(--font-size-xs);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
